import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Snackbar from 'material-ui/Snackbar';

const styles = theme => ({
  root: {
    /*
    '& > div': {
      backgroundColor: '#efefef',
    }
    */
		// '@media(max-width:760px)': {
		// 	flexGrow: 1
		// }
  },
  online: {
    color: theme.palette.primary['A700'],
  },
  offline: {
    color: theme.palette.common.accentOrange,
  },
  error: {
    color: theme.palette.error['A400'],
  },
});

class InspectionFormSnackBar extends Component {
  state = {
    open: false,
    currentMessage: undefined,
    currentOnlineStatus: undefined,
    shownFormErrorMessage: false,
    pendingMessages: [],
  };

  componentWillReceiveProps = nextProps => {
    const { formContext, online } = nextProps;
    if (nextProps === this.props) return;
    if (
      this.state.currentOnlineStatus === undefined ||
      this.props.online !== online
    ) {
      this.setState({
        currentOnlineStatus: online,
      });
      this.addMessage(
        online
          ? {
              message: 'Raportti tallentuu automaattisesti palvelimelle.',
              className: 'online',
            }
          : {
              message:
                'Ei verkkoyhteyttä. Raportti tallentuu vain tälle laitteelle, kunnes yhteys on saatavilla.',
              className: 'offline',
            }
      );
    }
    if (
      !this.state.shownFormErrorMessage &&
      formContext.shouldStrictValidate &&
      !formContext.isFormValid
    ) {
      this.setState({
        shownFormErrorMessage: true,
      });
      this.addMessage({
        message:
          'Lomakkeen voi allekirjoittaa vasta, kun virheelliset kentät on korjattu.',
        className: 'error',
      });
    }
  };

  addMessage = message => {
    const { open, pendingMessages } = this.state;
    if (open || pendingMessages.length) {
      this.setState({
        pendingMessages: [...pendingMessages, message],
      });
    } else {
      this.showMessage(message);
    }
  };

  showMessage = message => {
    this.setState({
      currentMessage: message,
      open: true,
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleExited = () => {
    const { pendingMessages } = this.state;
    if (pendingMessages.length) {
      const nextMessage = pendingMessages[0];
      this.setState({
        pendingMessages: [...pendingMessages.slice(1)],
      });
      this.showMessage(nextMessage);
    } else {
      this.setState({
        currentMessage: null,
      });
    }
  };

  render() {
    const { currentMessage, open } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          classes={{
            root: classes.root,
          }}
          onRequestClose={this.handleRequestClose}
          onExited={this.handleExited}
          open={open}
          autoHideDuration={60000}
          message={
            <span
              id="message-id"
              className={currentMessage && classes[currentMessage.className]}
            >
              {currentMessage && currentMessage.message}
            </span>
          }
        />
      </div>
    );
  }
}

InspectionFormSnackBar.propTypes = {
  classes: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  online: PropTypes.bool.isRequired,
};

export default withStyles(styles)(InspectionFormSnackBar);



// WEBPACK FOOTER //
// ./src/modules/inspection/components/InspectionFormSnackBar.js